import { render } from "./SortOrderIndicator.vue?vue&type=template&id=5f1ba7f8"
import script from "./SortOrderIndicator.vue?vue&type=script&lang=js"
export * from "./SortOrderIndicator.vue?vue&type=script&lang=js"

import "./SortOrderIndicator.vue?vue&type=style&index=0&id=5f1ba7f8&lang=css"
script.render = render

export default script